import * as API from './services'

export default API.services
